import { isValidImage, isValidVideo } from '@gorila-shared-ui/components';

export const getMediaTypeLabel = (url?: string, lowercase = true) => {
  let label = '';
  if (url) {
    if (isValidImage(url)) label = 'Foto';
    else if (isValidVideo(url)) label = 'Video';
  }
  return lowercase ? label.toLowerCase() : label;
};
